module.exports = __webpack_public_path__ + "static/img/sendIcon.5f29eb23.svg";